export default "__VITE_ASSET__CDhYIYH0__"